import { apiService } from "@/services";
import { settings } from "@/settings";
import { UsersClient } from "./GeneratedClients";

const userRepository = new UsersClient(settings.webApi.baseUrl, apiService.getApiClient());

export { userRepository };

